import React from 'react';
import { Checkbox, Col, Form, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { InfoCircleIcon } from '@/assets/icons/v2';

import { NoRiskAlert } from './styles';

const { useFormInstance } = Form;

const NO_RISK_FIELD = 'has_no_risk';
const HAS_KNOWN_INJURY_FIELD = 'has_known_injury';

interface NoRiskProps {
	fileId: string;
}

export function NoRisk({ fileId }: Readonly<NoRiskProps>): JSX.Element {
	const form = useFormInstance();

	function handleNoRiskChange({ target }: CheckboxChangeEvent): void {
		let hasKnownInjury: boolean | undefined;

		if (target.checked) {
			hasKnownInjury = false;
		}

		form.setFieldValue([fileId, HAS_KNOWN_INJURY_FIELD], hasKnownInjury);
	}

	return (
		<Row align="middle" gutter={[32, 8]}>
			<Col>
				<Form.Item noStyle name={[fileId, NO_RISK_FIELD]} valuePropName="checked">
					<Checkbox onChange={handleNoRiskChange}>{I18n.get('TLID without risk')}</Checkbox>
				</Form.Item>
			</Col>
			<Col flex="auto">
				<NoRiskAlert
					showIcon
					type="info"
					icon={<InfoCircleIcon />}
					message={I18n.get('Applicable to production order completion tasks')}
				/>
			</Col>
		</Row>
	);
}
